import React from 'react';
import { Helmet } from 'react-helmet-async';
import AboutContent from '../../components/Content/AboutContent';
import {
  Wrapper, Section, SectionTitle, Text, List, FeatureGrid, FeatureCard,
} from './About.styles';

export default function About() {
  return (
    <Wrapper>
      <Helmet>
        <title>Qué es Trastero · Sobre nosotros</title>
        <meta name="description" content="Trastero es el marketplace de segunda mano para vender y comprar artículos de tu garaje, trastero o bodega de forma fácil y segura." />
      </Helmet>
      <Section>
        <SectionTitle>¿Qué es Trastero?</SectionTitle>
        <Text>
          Trastero es una aplicación web moderna diseñada para ayudarte a organizar y gestionar
          tu inventario personal. Ya sea que tengas un trastero, garaje, bodega, rastro o simplemente
          quieras mantener un registro de tus pertenencias, Trastero te proporciona todas las
          herramientas que necesitas.
        </Text>
        <Text>
          Con una interfaz intuitiva y funcionalidades potentes, puedes cargar imágenes,
          crear categorías, buscar artículos rápidamente y mantener un control total de
          tus posesiones.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Características Principales</SectionTitle>
        <FeatureGrid>
          <FeatureCard>
            <h3>📸 Galería de Imágenes</h3>
            <p>Sube y organiza imágenes de tus artículos con facilidad</p>
          </FeatureCard>
          <FeatureCard>
            <h3>🔍 Búsqueda Avanzada</h3>
            <p>Encuentra rápidamente lo que necesitas con nuestro buscador</p>
          </FeatureCard>
          <FeatureCard>
            <h3>🏷️ Categorización</h3>
            <p>Organiza tus artículos por categorías personalizadas</p>
          </FeatureCard>
          <FeatureCard>
            <h3>👤 Perfil de Usuario</h3>
            <p>Gestiona tu información personal y preferencias</p>
          </FeatureCard>
          <FeatureCard>
            <h3>📱 Responsive Design</h3>
            <p>Accede desde cualquier dispositivo, en cualquier momento</p>
          </FeatureCard>
          <FeatureCard>
            <h3>⚡ Rendimiento</h3>
            <p>Aplicación rápida y optimizada para la mejor experiencia</p>
          </FeatureCard>
        </FeatureGrid>
      </Section>

      <Section>
        <SectionTitle>Tecnología</SectionTitle>
        <Text>Trastero está construido con las últimas tecnologías web modernas:</Text>
        <List>
          <li><strong>React 18</strong> — Biblioteca UI de última generación</li>
          <li><strong>React Router v6</strong> — Enrutamiento moderno y eficiente</li>
          <li><strong>Styled Components</strong> — Estilos dinámicos y reutilizables</li>
          <li><strong>Node/Express + PostgreSQL</strong> — Backend robusto</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Nuestra Misión</SectionTitle>
        <Text>
          Creemos que mantener organizadas nuestras posesiones es importante. Trastero nace
          con la misión de simplificar este proceso, permitiéndote enfocarte en lo que realmente
          importa mientras nosotros cuidamos del registro y la organización de tus artículos.
        </Text>
      </Section>

      <Section>
        <SectionTitle>Resumen Rápido</SectionTitle>
        <AboutContent />
      </Section>
    </Wrapper>
  );
}
